export default function PillsSection({ heading, data }) {
	if (!data) return;
	return (
		<div>
			{heading && <p className='tw-font-bold tw-mb-2 tw-text-sm'>{heading}</p>}
			<div className='tw-flex tw-gap-2 tw-flex-wrap tw-basis-1/2'>
				{data.split(';').map((item, i) => (
					<div
						key={i}
						className='tw-text-xs tw-font-semibold tw-px-3 tw-py-1 tw-rounded-full tw-bg-emerald-100  tw-text-emerald-700'>
						{item}
					</div>
				))}
			</div>
		</div>
	);
}
